// Convert Persian/Arabic-Indic digits to normal Latin digits,
// since Iranian keyboards often produce ۰۱۲۳... instead of 0123...
export const toEnglishDigits = (str = '') =>
  str
    .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));

// Strips +98 / 0098 / 98 / leading 0, keeps only digits, caps at 10.
// Always returns the bare 10-digit subscriber number (e.g. 9123456789).
export const normalizeIranPhone = (raw) => {
  let digits = toEnglishDigits(raw).replace(/\D/g, '');

  if (digits.startsWith('0098')) digits = digits.slice(4);
  else if (digits.startsWith('98')) digits = digits.slice(2);
  else if (digits.startsWith('0')) digits = digits.slice(1);

  return digits.slice(0, 10);
};

export const isValidIranPhone = (digits) => /^9\d{9}$/.test(digits);